import React from "react";

// Shown while an admin is viewing the app as a member; one tap returns to the admin session.
export const ViewAsBanner = () => {
  const admin = localStorage.getItem("reclaim_admin_token");
  if (!admin) return null;
  const back = () => {
    localStorage.setItem("reclaim_token", admin);
    ["reclaim_admin_token", "reclaim_view_as", "reclaim_user_cache"].forEach((k) => localStorage.removeItem(k));
    window.location.href = "/admin/users";
  };
  return (
    <div className="fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-3 px-4 py-1.5 text-xs"
      style={{ background: "#d6be82", color: "#0b1430", fontFamily: '"Manrope", sans-serif' }} data-testid="view-as-banner">
      <span>Viewing as <strong data-testid="view-as-name">{localStorage.getItem("reclaim_view_as")}</strong></span>
      <button type="button" onClick={back} className="underline font-semibold" data-testid="view-as-exit">Back to admin</button>
    </div>
  );
};
